import { socialMediaData } from "./socialMediaData";

export const navbarData = {
  labels: [
    { name: "Start", to: "/" },
    { name: "Oferta", to: "/offer" },
    { name: "Aktualności", to: "/blog" },
    { name: "Współpraca", to: "/cooperation" },
    { name: "Najczęstsze pytania", to: "/questions" },
    { name: "O Nas", to: "/about" },
  ],
  socials: socialMediaData,
  aria: {
    closeLabel: "Zamknij menu",
    openLabel: "Otwórz menu",
  },
};
